import React from 'react'

interface Props {
    inputRef: React.RefObject<HTMLInputElement>
    value: string
    placeholder?: string
    disabled?: boolean
    onOpen(): void
    onChange(value: string): void
    onBlur(): void
    testId: string
    styles: Record<string, any>
}

/**
 *
 */
const SearchableField = ({
    inputRef,
    value,
    placeholder,
    disabled,
    onOpen,
    onChange,
    onBlur,
    testId,
    styles
}: Props): JSX.Element => {
    return (
        <input
            ref={inputRef}
            value={value}
            onFocus={onOpen}
            onClick={onOpen}
            onBlur={onBlur}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className='searchable-input-field'
            style={styles.input}
            disabled={disabled}
            data-testid={testId}
            autoComplete='off'
        />
    )
}

export default SearchableField
